import { LANES, LANE_WIDTH } from '@accra/shared';

/** Cross-section of the dual carriageway, metres from our road's centre (right = positive x). */
const ROAD_HALF = (LANES * LANE_WIDTH) / 2;
const MEDIAN_WIDTH = 2.6;
const OPPOSITE_WIDTH = LANES * LANE_WIDTH;
const SIDEWALK_WIDTH = 4;

export const LAYOUT = {
  tileLength: 40,
  roadHalf: ROAD_HALF,
  kerbX: ROAD_HALF + 0.15,
  gutterX: ROAD_HALF + 0.7,
  gutterWidth: 0.8,
  sidewalkX: ROAD_HALF + 1.1 + SIDEWALK_WIDTH / 2,
  sidewalkWidth: SIDEWALK_WIDTH,
  buildingFrontX: ROAD_HALF + 1.1 + SIDEWALK_WIDTH + 0.3,
  medianX: -ROAD_HALF - MEDIAN_WIDTH / 2,
  medianWidth: MEDIAN_WIDTH,
  oppositeRoadX: -ROAD_HALF - MEDIAN_WIDTH - OPPOSITE_WIDTH / 2,
  oppositeRoadWidth: OPPOSITE_WIDTH,
  leftSidewalkX: -ROAD_HALF - MEDIAN_WIDTH - OPPOSITE_WIDTH - SIDEWALK_WIDTH / 2,
  leftBuildingFrontX: -ROAD_HALF - MEDIAN_WIDTH - OPPOSITE_WIDTH - SIDEWALK_WIDTH - 0.3,
} as const;

/** Middle of a lane on the far carriageway (lane 0 is the one by the median, like ours). */
export function oppositeLaneX(lane: number): number {
  return LAYOUT.oppositeRoadX + (lane - (LANES - 1) / 2) * LANE_WIDTH;
}
